import textMessagingSubCategory from './textMessagingSubCategory';
export default textMessagingSubCategory;
